import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { createAction } from 'typesafe-actions';

export const setFeatureFlags = createAction('featureFlags/SET_FEATURE_FLAGS')<LDFlagSet>();
